import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderRefundPaymentAddPage } from 'src/app/modals/order-refund-payment-add/order-refund-payment-add.page';

const routes: Routes = [
  {
    path: '',
    component: OrderRefundPaymentAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderRefundPaymentAddPage]
})
export class OrderRefundPaymentAddPageModule {}
